module.exports = __webpack_public_path__ + "img/项目场景_智慧工地观摩.62e084b3.jpg";